import { useMemo } from 'react';

import {
  builderUnified,
  getCertifications,
  getEducations,
  getLanguages,
  getSkills,
  getWorkHistory,
} from 'components/resumeBuilder/common';

export const RESUME_BUILDER_DATA_SETTINGS = {
  WAY: {
    DEFAULT: 'default',
    UNIFIED: 'unified',
  },
};

const OPTIONS_DEFAULT = {
  way: RESUME_BUILDER_DATA_SETTINGS.WAY.DEFAULT,
};

/**
 * useResumeBuilderData
 *
 * @param {Object} data - resume builder data
 * @param {String} dateFormat - format of date
 */
export const useResumeBuilderData = (data = {}, options = OPTIONS_DEFAULT) => {
  const dateFormat = 'MMMM YYYY';
  const appendDegree = false;

  const { way } = options;

  const {
    workHistory: workHistoryData,
    education: educationsData,
    certifications: certificationsData,
    skills: skillsData,
    languages: languagesData,
    header: headerData,
    summary,
  } = data;

  const workHistory = useMemo(() => {
    if (way === RESUME_BUILDER_DATA_SETTINGS.WAY.UNIFIED) {
      return builderUnified.workHistory(workHistoryData, dateFormat);
    }

    const workHistoryList = getWorkHistory(workHistoryData, dateFormat);
    if (Array.isArray(workHistoryList)) {
      workHistoryList.sort((a, b) => a.order - b.order);
    }

    return workHistoryList;
  }, [workHistoryData]);
  const educations = useMemo(() => {
    if (way === RESUME_BUILDER_DATA_SETTINGS.WAY.UNIFIED) {
      return builderUnified.education(educationsData, dateFormat);
    }

    const educationList = getEducations(educationsData, dateFormat, '-', appendDegree);
    if (Array.isArray(educationList)) {
      educationList.sort((a, b) => a.order - b.order);
    }
    return educationList;
  }, [educationsData]);
  const certifications = useMemo(
    () => getCertifications(certificationsData, dateFormat),
    [certificationsData]
  );
  const skills = useMemo(() => {
    if (way === RESUME_BUILDER_DATA_SETTINGS.WAY.UNIFIED) {
      return builderUnified.skill(skillsData);
    }

    return getSkills(skillsData);
  }, [skillsData]);
  const languages = useMemo(() => {
    if (way === RESUME_BUILDER_DATA_SETTINGS.WAY.UNIFIED) {
      return builderUnified.language(languagesData);
    }

    return getLanguages(languagesData);
  }, [languagesData]);

  const header = builderUnified.contactInfo(headerData, workHistoryData, summary);

  return {
    workHistory,
    educations,
    certifications,
    skills,
    languages,
    header,
  };
};
